import { defineMessages, useIntl } from 'react-intl';

import MoreHorizIcon from '@/material-icons/400-24px/more_horiz.svg?react';
import { openModal } from 'mastodon/actions/modal';
import { Avatar } from 'mastodon/components/avatar';
import { DisplayName } from 'mastodon/components/display_name';
import { Dropdown } from 'mastodon/components/dropdown_menu';
import { Icon } from 'mastodon/components/icon';
import { useAccount } from 'mastodon/hooks/useAccount';
import { me } from 'mastodon/initial_state';
import type { MenuItem } from 'mastodon/models/dropdown_menu';
import { useAppDispatch } from 'mastodon/store';

const messages = defineMessages({
  preferences: {
    id: 'navigation_bar.preferences',
    defaultMessage: 'Preferences',
  },
  displaySettings: {
    id: 'navigation_bar.display_settings',
    defaultMessage: 'Appearance',
  },
  accountSettings: {
    id: 'navigation_bar.account_settings',
    defaultMessage: 'Password and security',
  },
  importExport: {
    id: 'navigation_bar.import_export',
    defaultMessage: 'Import and export',
  },
  privacyAndReach: {
    id: 'navigation_bar.privacy_and_reach',
    defaultMessage: 'Privacy and reach',
  },
  logout: { id: 'navigation_bar.logout', defaultMessage: 'Logout' },
});

export const AccountMenu: React.FC = () => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const account = useAccount(me);

  if (!account) {
    return null;
  }

  const handleLogoutClick = () => {
    dispatch(openModal({ modalType: 'CONFIRM_LOG_OUT', modalProps: {} }));
  };

  const menu: MenuItem[] = [
    {
      href: '/settings/preferences',
      text: intl.formatMessage(messages.preferences),
    },
    {
      to: '/settings/display',
      text: intl.formatMessage(messages.displaySettings),
    },
    {
      href: '/settings/privacy',
      text: intl.formatMessage(messages.privacyAndReach),
    },
    {
      href: '/auth/edit',
      text: intl.formatMessage(messages.accountSettings),
    },
    {
      href: '/settings/export',
      text: intl.formatMessage(messages.importExport),
    },
    null,
    {
      text: intl.formatMessage(messages.logout),
      action: handleLogoutClick,
    },
  ];

  return (
    <Dropdown items={menu} placement='top-start'>
      <button type='button' className='navigation-panel__account-menu'>
        <Avatar account={account} size={36} />

        <div className='navigation-panel__account-menu__details'>
          <DisplayName
            account={account}
            variant='simple'
            className='navigation-panel__account-menu__display-name'
          />
          <span className='navigation-panel__account-menu__handle'>
            @{account.acct}
          </span>
        </div>

        <Icon
          id=''
          icon={MoreHorizIcon}
          className='navigation-panel__account-menu__more'
        />
      </button>
    </Dropdown>
  );
};
